module.exports = __webpack_public_path__ + "04_veryshort_beige.de6375ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_veryshort_beige.png
// module id = hPAd
// module chunks = 0